import { isMobileOnly } from 'react-device-detect';

export const useStyles = () => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: isMobileOnly ? '50%' : 'auto',
      // marginBottom: 4,
    },
    video: {
      borderRadius: '8px',
      overflow: 'hidden',
      position: 'relative',
    },
    loading: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    select: {
      marginTop: '-24px',
      background: '#03030366',
      border: 'none !important',
      height: '32px',

      '& .MuiInput-input': {
        textAlign: 'left',
        paddingLeft: 1,
      },
    },
  };
};
